import { debounce } from 'throttle-debounce';
import { SEARCH, SETTINGS } from '../../utils/constants';

const initSearch = () => {
  const predictiveSearchEl = document.querySelector('[data-predictive-search]');
  if (!predictiveSearchEl) return;
  const headerEl = document.querySelector('[data-header-container]');
  const searchOpenBtn = headerEl?.querySelector('[data-toggle-search]');
  const searchCloseBtn = predictiveSearchEl.querySelector('[data-predictive-search-close]');

  const searchInputEl = predictiveSearchEl.querySelector('input[type="search"]');
  const resultsEl = predictiveSearchEl.querySelector('[data-predictive-search-results]');
  if (!searchInputEl || !resultsEl || !searchOpenBtn) return;

  const settings = JSON.parse(predictiveSearchEl.dataset.settings || '{}');

  const openResults = () => resultsEl.classList.remove('hidden');

  const closeResults = () => {
    searchInputEl.value = '';
    resultsEl.innerHTML = '';
    resultsEl.classList.add('hidden');
  };

  const openSearch = () => {
    searchOpenBtn.classList.add(SEARCH.OPEN);
    predictiveSearchEl.classList.remove('hidden');
    searchOpenBtn.setAttribute('aria-expanded', 'true');
  };

  const closeSearch = () => {
    searchOpenBtn.classList.remove(SEARCH.OPEN);
    predictiveSearchEl.classList.add('hidden');
    searchOpenBtn.setAttribute('aria-expanded', 'false');
    closeResults();
  };

  const toggleSearch = () => {
    if (searchOpenBtn.classList.contains(SEARCH.OPEN)) {
      closeSearch();
    } else {
      openSearch();
    }
  };

  const fetchResults = async (query) => {
    const url = `${window.Shopify.routes.root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=query,${settings?.type}&resources[options][fields]=${settings?.fields}&resources[limit]=${settings?.limit}&resources[options][unavailable_products]=${settings?.oos}&section_id=predictive-search`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        closeResults();
        throw new Error(`Fetch failed: ${response.status}`);
      }

      const htmlText = await response.text();
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const section = html.querySelector('#shopify-section-predictive-search');

      if (section) {
        resultsEl.innerHTML = section.innerHTML;
        openResults();
      } else {
        closeResults();
      }
    } catch (error) {
      closeResults();
      console.error('Search error:', error);
    }
  };

  const handleInput = () => {
    const value = searchInputEl.value.trim();
    if (value.length < settings.trigger) return;
    fetchResults(value);
  };

  const debouncedHandleInput = debounce(SETTINGS.SEARCH_DEBOUNCE_DELAY, handleInput);
  searchInputEl.addEventListener('input', debouncedHandleInput);

  document.addEventListener('click', (event) => {
    const target = event.target;
    const clickedInsideSearch = predictiveSearchEl.contains(target);
    const clickedOpenBtn = searchOpenBtn.contains(target);
    if (!clickedInsideSearch && !clickedOpenBtn) {
      if (searchOpenBtn.classList.contains(SEARCH.OPEN)) closeSearch();
    }
  });

  searchOpenBtn.addEventListener('click', toggleSearch);
  searchCloseBtn?.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (evt) => {
    if (evt.key === 'Escape' && searchOpenBtn.classList.contains(SEARCH.OPEN)) {
      closeSearch();
    }
  });
};

export default initSearch;
